import { DispatcherEvent } from '@carvana/merch-native';
import { useContext, useEffect, useRef } from 'react';
import RecentSearchesContext from '~/context/home/RecentSearchesContext';
import sendMessageToNative from './sendMessageToNative';

export default function usePageReadyDispatcher() {
  const pageReady = useRef(false);
  const {
    recentSearches: { isLoading, isLoaded }
  } = useContext(RecentSearchesContext);

  const isRecentSearchesComplete = !isLoading && isLoaded;

  useEffect(() => {
    if (!pageReady.current && isRecentSearchesComplete) {
      sendMessageToNative(DispatcherEvent.PageReady, {});
      pageReady.current = true;
    }
  }, [isRecentSearchesComplete]);
}
